import styled from 'styled-components';
import { PopoverBody } from '@becreatives/becreatives-ui';

const StyledPopoverBody = styled(PopoverBody)``;

export { StyledPopoverBody };
